/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FirmwareDeploymentRequest
 */
export interface FirmwareDeploymentRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FirmwareDeploymentRequest
     */
    upgradeRuleIds: Array<string>;
}

export function FirmwareDeploymentRequestFromJSON(json: any): FirmwareDeploymentRequest {
    return FirmwareDeploymentRequestFromJSONTyped(json, false);
}

export function FirmwareDeploymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareDeploymentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'upgradeRuleIds': json['upgradeRuleIds'],
    };
}

export function FirmwareDeploymentRequestToJSON(value?: FirmwareDeploymentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'upgradeRuleIds': value.upgradeRuleIds,
    };
}

